import React from "react";
import Box from "@mui/joy/Box";
import IGrid from "./IGrid";
import InfoCard from "./InfoCard";
import Container from "@mui/joy/Container";

const Header = () => (
  <Box
    component="header"
    sx={{
      position: "relative",
      overflow: "hidden",
      width: "100%",
      paddingTop: "64px",
      paddingBottom: "80px",
    }}
  >
    <IGrid
      columns={111}
      rows={36}
      style={{
        position: "absolute",
        top: "-50%",
        left: "-11px",
        transform: "skewY(11deg)",
        width: "100%",
        height: "100%",
      }}
    />
    <Container
      sx={{
        position: "relative",
        zIndex: 1,
        mx: "auto",
        width: { xs: "90%", sm: "70%", md: "70%", lg: "50%" },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <InfoCard />
    </Container>
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        width: '100%',
        height: '24px',
        background: 'linear-gradient(to bottom, transparent, white)',
        pointerEvents: 'none',
      }}
    />
  </Box>
);

export default Header;
